import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-ticket-type',
  templateUrl: './modify-ticket-type.component.html',
  styleUrls: ['./modify-ticket-type.component.css']
})
export class ModifyTicketTypeComponent implements OnInit {



  editForm: any | FormGroup
  modelSubtitle = false

  tickets: any = []
  checked = false

  isActive = false
  tickettypeId: any = "";
  cid:any
  serviceData: any = []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getalltickets()
    this.editForm = this.fb.group({
      name: [''],
      version: [''],
      serviceType: [''],
      isPubliclyVisible: true,
      isActive: [''],
      id: ['']
    })
    this.getAllServices()
  }

  getAllServices(){
    this.generic_service.getAllServices().subscribe(
      (response:any)=>{
        this.serviceData = response.response;
        console.log(response)
      }
    )
  }

  updateTicketType(){

    let body = {
      "version": Number(this.editForm.get('version').value),
      "isActive": this.checked,
      "description": "",
      "serviceType": String(this.editForm.get('serviceType').value),
      "id": this.editForm.get('id').value,
      "ticketTypeId": this.tickettypeId,
      "name": String(this.editForm.get('name').value),
      "remarks": "",
      "isPubliclyVisible": Boolean(this.editForm.get('isPubliclyVisible').value),
      "displayOrder": "",
      "cid": Number(this.cid),
      
    }

    console.log(body)
    this.generic_service.updateTicketType(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getalltickets()
        this.toastr.success("Successfully Updated");
        this.cancelModel()

      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getalltickets(){
    this.generic_service.getAllTickets().subscribe(
      (response:any)=>{
        this.tickets = response.response;
        console.log(response)
      }
    )
  }

  radiocheck(){
    if(this.checked){
      this.checked = false
    }
    else{
      this.checked = true
    }
  }

  getTicketTypeById(id:any){
    this.tickettypeId = id
    this.generic_service.getTicketTypeById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.editForm.patchValue({
          name: response.response.name,
          version: response.response.version,
          isPubliclyVisible: response.response.isPubliclyVisible,
          isActive: response.response.isActive,
          id: response.response.id
        })
        console.log(this.editForm.value)
      },
      (error)=>{
        console.log(error)
      }
    )
  }

  // editskill(){

  //   this.tickets[this.i].name=this.name
  //   this.tickets[this.i].version=this.version
  //   this.tickets[this.i].isActive = this.isActive;
  //   this.close()
  // }
  // open() {
  //   this.modelSubtitle = true;
  // }
  // close() {
  //   this.modelSubtitle = false;
  //   this.name = ""
  //   this.version = ""
  //   this.isActive = false

  // }

  // edit(i:any){
  //   this.open();
  //   this.name = this.tickets[i].name;
  //   this.version = this.tickets[i].version ;
  //   this.isActive = this.tickets[i].isActive
  // }

}